import { NetworkConnectivity as SERVICE_WORKER_NetworkConnectivity } from '../../../../ServiceWorker/src/helpers/network-connectivity';

export { SERVICE_WORKER_NetworkConnectivity as NetworkConnectivity };
